document.addEventListener("DOMContentLoaded", (event) => {
  gsap.registerPlugin(ScrollTrigger);

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  var mod = false;
  var base = 140,
    mid = 240,
    lg = 300;

  if (document.body.classList.contains("book-series--parent")) {
    if (document.querySelector(".page-header__hero--mod")) {
      mod = true;
      base = 80;
      mid = 110;
      lg = 120;
    }

    if (!prefersReducedMotion()) {
      gsap.set(".single-book-series .hero__middle", {
        top: (i, el) => base,
      });

      gsap.set(".single-book-series .hero__focal", {
        top: (i, el) => mid,
      });

      gsap.set(".single-book-series .hero__fg", {
        top: (i, el) => lg,
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: $(".single-book-series .page-header__hero"),
          pin: false,
          scrub: true,
          start: "top",
          end: "top+=50%",
          toggleActions: "play pause resume reset",
          markers: false,
        },
      });

      gsap.to(".single-book-series .hero__middle", {
        top: (i, el) => -($(el).outerHeight() * $(el).data("depth")),
        scrollTrigger: {
          trigger: $(".single-book-series .page-header__hero"),
          pin: false,
          scrub: true,
          start: "top",
          end: "top+=25%",
        },
        force3D: true,
      });

      gsap.to(".single-book-series .hero__focal", {
        top: (i, el) => -($(el).outerHeight() * $(el).data("depth")),
        scrollTrigger: {
          trigger: $(".single-book-series .page-header__hero"),
          pin: false,
          scrub: true,
          start: "top",
          end: "top+=25%",
        },
        force3D: true,
      });

      gsap.to(".single-book-series .hero__fg", {
        top: (i, el) => -($(el).outerHeight() * $(el).data("depth")),
        scrollTrigger: {
          trigger: $(".single-book-series .page-header__hero"),
          pin: false,
          scrub: true,
          start: "top",
          end: "top+=35%",
        },
        force3D: true,
      });

      ScrollTrigger.create({
        trigger: $(".single-book-series .page-header__hero"),
        start: "top",
        end: "top+=50%",
        onLeave: () => {
          ScrollTrigger.getById("pin").disable();
        },
        onEnterBack: () => {
          ScrollTrigger.getById("pin").enable();
        },
        id: "pin",
      });

      tl.to(".single-book-series .page-header__hero--desktop h1", {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        opacity: 1,
      })
        .to(".single-book-series .page-header__hero--desktop h1", {
          position: "fixed",
          top: 0,
          opacity: 0,
        })
        .to(".single-book-series .page-header__hero--desktop h1", {
          position: "absolute",
        });
    }
  }

  if (document.body.classList.contains("home")) {
    if (!prefersReducedMotion()) {
      // gsap.ticker.lagSmoothing(0);

      if (document.querySelector(".hero__bg--cube-one")) {
        gsap.to(".hero__bg--cube-one", {
          y: "-20",
          duration: 3,
          repeat: -1,
          yoyo: true,
          ease: "power1.inOut",
          force3D: true,
        });
      }

      if (document.querySelector(".hero__bg--cube-two")) {
        gsap.to(".hero__bg--cube-two", {
          y: "-10",
          duration: 2.5,
          repeat: -1,
          yoyo: true,
          ease: "power1.inOut",
          force3D: true,
        });
      }

      if (document.querySelector(".hero__bg--cube-three")) {
        gsap.to(".hero__bg--cube-three", {
          y: "-15",
          duration: 2,
          repeat: -1,
          yoyo: true,
          ease: "power1.inOut",
          force3D: true,
        });
      }

      if (document.querySelector(".hero__bg--cube-five")) {
        gsap.to(".hero__bg--cube-five", {
          y: "-25",
          duration: 4,
          repeat: -1,
          yoyo: true,
          ease: "power1.inOut",
          force3D: true,
        });
      }
    }
  }
});
